import classNames from 'classnames';
import { formatPrice } from '@/forApp/utils/formatPrice';

import styles from './prices.module.css';

type PricesProps = {
  size?: 'medium' | 'small';
  className?: string;
  price: number;
  priceMeter: number;
  totalArea: number;
};

const Prices = ({
  className,
  size,
  price,
  priceMeter,
  totalArea,
}: PricesProps) => {
  return (
    <div className={classNames(styles.wrap, className, size && styles[size])}>
      <div className={styles.price}>{formatPrice(price)}</div>
      <div className={styles.priceMeter}>
        {formatPrice(priceMeter)}/м<sup>2</sup>
      </div>
      <div className={styles.totalArea}>
        {totalArea} м<sup>2</sup>
      </div>
    </div>
  );
};

export default Prices;
